import { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import Seo from "../components/Seo";

const Lehrpersonen = () => {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/teachers").then(r => setItems(r.data)); }, []);

  return (
    <div data-testid="teachers-page">
      <Seo
        title="Lehrpersonen – Tamilische Musik- & Tanzlehrer"
        description="Lerne die Lehrpersonen der KK Academy kennen – erfahrene Künstler aus der tamilischen Community in der Schweiz."
        path="/lehrpersonen"
        keywords="Tamilische Musiklehrer, Tamilische Tanzlehrer, Mirudangam Lehrer, Bharatanatyam Lehrerin"
      />
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">{t("nav.teachers")}</div>
        <h1 className="font-serif-display text-5xl md:text-6xl leading-[1.05] max-w-3xl mb-12">{t("home.teachersTitle")}</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((tch) => (
            <div key={tch.id} className="card-academy rounded-lg overflow-hidden">
              <div className="aspect-[4/5] overflow-hidden">
                <img src={tch.photo} alt={tch.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-[0.3em] text-primary mb-2">{tch.role}</div>
                <h3 className="font-serif-display text-2xl mb-1">{tch.name}</h3>
                <div className="text-xs text-muted-foreground mb-4">{tch.department}</div>
                <p className="text-sm text-muted-foreground mb-4">{tch.bio}</p>
                <div className="text-xs space-y-1 border-t border-border pt-4">
                  {tch.experience && <div><span className="text-muted-foreground">Erfahrung: </span>{tch.experience}</div>}
                  {tch.education && <div><span className="text-muted-foreground">Ausbildung: </span>{tch.education}</div>}
                  {tch.languages?.length > 0 && <div><span className="text-muted-foreground">Sprachen: </span>{tch.languages.join(", ")}</div>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Lehrpersonen;
